import { connect } from 'react-redux';
import { restoreSession, fetchContent } from 'store/actions';
import App from './App';

const mapDispatchToProps = dispatch => ({
  initialize: () => {
    dispatch(restoreSession());
    dispatch(fetchContent());
  }
});

export default connect(
  state => state,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/components/App/connectToStore.js